import React from 'react';

/**
 * Field label atom with optional trailing hint (e.g. character count).
 */
export default function FieldLabel({ children, hint, htmlFor, className = '' }) {
  return (
    <div className={`ca-field-label ${className}`.trim()}>
      <label className="ca-label" htmlFor={htmlFor}>
        {children}
      </label>
      {hint != null ? <span className="ca-field-label__hint">{hint}</span> : null}
    </div>
  );
}
